import { create } from 'zustand'

/**
 * Calls shown in the floating dock: the ones this tab started plus live calls pushed to the user
 * (e.g. an inbound call routed to them). `promptedDisposition` remembers which ended calls already
 * opened the disposition dialog so it opens once.
 */
interface CallState {
  activeCallIds: string[]
  promptedDisposition: string[]
  dispositionCallId: string | null

  addCall: (callId: string) => void
  dismissCall: (callId: string) => void
  openDisposition: (callId: string) => void
  closeDisposition: () => void
  clear: () => void
}

export const useCallStore = create<CallState>((set) => ({
  activeCallIds: [],
  promptedDisposition: [],
  dispositionCallId: null,

  addCall: (callId) =>
    set((state) => (state.activeCallIds.includes(callId) ? state : { activeCallIds: [callId, ...state.activeCallIds].slice(0, 3) })),
  dismissCall: (callId) => set((state) => ({ activeCallIds: state.activeCallIds.filter((id) => id !== callId) })),
  openDisposition: (callId) =>
    set((state) => ({
      dispositionCallId: callId,
      promptedDisposition: state.promptedDisposition.includes(callId)
        ? state.promptedDisposition
        : [...state.promptedDisposition, callId],
    })),
  closeDisposition: () => set({ dispositionCallId: null }),
  clear: () => set({ activeCallIds: [], promptedDisposition: [], dispositionCallId: null }),
}))
